import {forwardRef} from 'react';
import {Section} from '@baidu/luffy-comp-section';
import classNames from 'classnames';

import {Props, BindEventProps} from '@/interface';
import styles from './index.module.scss';
export interface TextSectionProps extends Props {
    headlinePrimary?: React.ReactNode;
    headlineSecondary?: React.ReactNode;
}

export function TextSection(props: TextSectionProps) {
    const {children, ...sectionProps} = props;
    return (
        <Section {...sectionProps}>
            {children}
        </Section>
    );
}

export enum TextType {
    T18 = 't18',
    T16 = 't16',
    T14 = 't14',
    T13 = 't13',
    T12 = 't12',
    T10 = 't10',
}

export enum TextColor {
    Error = 'error',
    Warning = 'warning',
    Primary = 'primary',
    Secondary = 'secondary',
    Disabled = 'disabled',
    Dark = 'dark',
    White = 'white',
    Link = 'link',
    Info = 'info',
    Normal = 'normal',
}

export interface TextProps extends BindEventProps {
    type?: TextType;
    color?: TextColor;
    bold?: boolean;
    className?: string;
    title?: string;
    onDoubleClick?: () => void;
    onClick?: () => void;
}


const Text = forwardRef<HTMLSpanElement, TextProps>((props: TextProps, ref) => {

    const {type, color, bold, className, title, children, ...textProps} = props;
    const typeClass = type ? styles[type] : styles.t14;
    const colorClass = color ? styles[color] : styles.primary;
    const boldClass = bold ? styles.bold : '';
    const textClassName = classNames(typeClass, colorClass, boldClass, className);
    return (
        <span className={textClassName} {...textProps} ref={ref} title={title}>
            {children}
        </span>
    );
});

export default Text;
